/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Logo_AltInputs */

const en_company_profile_logo_alt = /** @type {(inputs: Company_Profile_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company logo`)
};

const de_company_profile_logo_alt = /** @type {(inputs: Company_Profile_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmenslogo`)
};

/**
* | output |
* | --- |
* | "Company logo" |
*
* @param {Company_Profile_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_logo_alt = /** @type {((inputs?: Company_Profile_Logo_AltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Logo_AltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_logo_alt(inputs)
	return en_company_profile_logo_alt(inputs)
});